import {
  HUD87_CAPABILITY_PAST_LINE_COLOR,
  HUD87_CAPABILITY_PAST_LINE_STROKE_WIDTH_PX,
  HUD87_CURRENT_POINT_DOT_RADIUS_PX,
} from "../../../hud/variants"
import {
  DESKTOP_FUTURE_LINE_COLOR,
  DESKTOP_FUTURE_LINE_STROKE_PX,
  MOBILE_STRIP_LINE_STROKE_PX,
  MOBILE_STRIP_TIP_DOT_RADIUS_PX,
  type CapabilityLineArt,
} from "./capabilityLineArt"

// The active plan's line: black future projection under the past line,
// with the current-point dot riding the tip.
export const CapabilityLineSvg = ({
  art,
  isDesktopMirror,
  textColor,
  backgroundColor,
}: {
  art: CapabilityLineArt
  isDesktopMirror: boolean
  textColor: string
  backgroundColor: string
}) => (
  <>
    {art.futureLinePath !== null && (
      <path
        d={art.futureLinePath}
        stroke={DESKTOP_FUTURE_LINE_COLOR}
        strokeWidth={DESKTOP_FUTURE_LINE_STROKE_PX}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    )}
    <path
      d={art.pastLinePath}
      stroke={isDesktopMirror ? HUD87_CAPABILITY_PAST_LINE_COLOR : textColor}
      strokeWidth={isDesktopMirror
        ? HUD87_CAPABILITY_PAST_LINE_STROKE_WIDTH_PX
        : MOBILE_STRIP_LINE_STROKE_PX}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {isDesktopMirror ? (
      // Desktop's solid→dashed transition dot: filled, line-colored.
      <circle
        cx={art.tip.x}
        cy={art.tip.y}
        r={HUD87_CURRENT_POINT_DOT_RADIUS_PX}
        fill={HUD87_CAPABILITY_PAST_LINE_COLOR}
      />
    ) : (
      <circle
        cx={art.tip.x}
        cy={art.tip.y}
        r={MOBILE_STRIP_TIP_DOT_RADIUS_PX}
        fill={backgroundColor}
        stroke={textColor}
        strokeWidth={1.6}
      />
    )}
  </>
)
